import React from 'react';
import { ArrowUpRight, ArrowDown } from 'lucide-react';
import { heroImage, stats } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Premium London property"
          className="w-full h-full object-cover hero-img"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f0f10]/60 via-[#0f0f10]/40 to-[#0f0f10]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f0f10]/80 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-16 md:pb-24">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-14 h-px bg-[#e4cfaf]" />
          <p className="uppercase text-[11px] md:text-xs tracking-[0.28em] text-white/80">
            HMO Management Specialists &middot; Kent, West, South East &amp; East London
          </p>
        </div>

        <h1 className="serif text-white leading-[0.95] max-w-4xl">
          <span className="block text-[15vw] md:text-[7.2rem] lg:text-[8.2rem]">Guaranteed rent.</span>
          <span className="block text-[15vw] md:text-[7.2rem] lg:text-[8.2rem]">Zero stress.</span>
          <span className="block italic-serif text-[13vw] md:text-[6.6rem] lg:text-[7.4rem] pl-2 md:pl-6">
            Fully managed.
          </span>
        </h1>

        <p className="mt-10 max-w-xl text-white/70 text-lg md:text-xl leading-relaxed">
          MSR Residential Group gives landlords a hands-off, fully managed rent-to-rent solution
          &mdash; with guaranteed monthly rent and zero void periods.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#contact"
            className="btn-primary px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
          >
            Book a Call <ArrowUpRight className="w-4 h-4" />
          </a>
          <a
            href="#process"
            className="btn-outline px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
          >
            How it works
          </a>
        </div>

        {/* Stats card */}
        <div className="mt-20 md:mt-28 border border-white/10 bg-[#0f0f10]/70 backdrop-blur-md rounded-sm">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-white/10">
            {stats.map((s) => (
              <div key={s.label} className="px-6 py-8 md:py-10 text-center">
                <div className="serif text-[#e4cfaf] text-5xl md:text-6xl mb-3">{s.value}</div>
                <div className="uppercase text-[10px] md:text-xs tracking-[0.24em] text-white/60">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 md:right-14 z-10 hidden md:flex flex-col items-center gap-2 text-white/50">
        <span className="uppercase text-[10px] tracking-[0.3em] rotate-90 origin-center mt-4">Scroll</span>
        <ArrowDown className="w-4 h-4 mt-8 animate-bounce" />
      </div>
    </section>
  );
}
